import { extend, noop, template } from 'lodash';
import ApplicationController from './application_controller';

/* global Backbone, Mn, Cifra, $, init_datepicker */

const CHANNEL = Backbone.Radio.channel('modalHtml');
Cifra.Channels.ModalHtml = CHANNEL;

const MODAL_HOLDER_ID = 'modal-html-holder';
Cifra.Modals.addHolder(MODAL_HOLDER_ID);

const MODAL_TEMPLATE = template(`
<div class="modal fade" tabindex="-1" role="dialog" id="<%= id %>">
  <div class="modal-dialog <%= modalClasses %>" role="document">
    <div class="modal-content">
      <% if (title){ %>
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span></button>
          <h5 class="border-bottom modal-title"><%= title %></h5>
        </div>
      <% } %>
      <div class="modal-body">
      </div>
    </div>
  </div>
</div>
`);

/*
  Se trata de un modal que se carga el html llamando al servidor. Cuando se hace el submit,
  la respuesta es el html del form que se vuelve a renderizan en el modal si ha habido algún error
  o se cierra el modal si todo fue bien.
  La gestión del renderizado del formulario está en el servidor, no se gestiona con json
  Idea: https://jtway.co/5-steps-to-add-remote-modals-to-your-rails-app-8c21213b4d0c

  Si el servidor devuelve el status code 200, cerramos el modal
  @deprecated: Hay que utilizar el controlador modal-remoto
*/
Cifra.Components.ModalHtml = Mn.View.extend({
  template: noop,
  events: {
    // eslint-disable-next-line quote-props
    'click': 'onClick',
  },
  initialize() {
    this.modalHolderId = this.getOption('modalHolderId') || MODAL_HOLDER_ID;
    Cifra.Modals.ensureHolder(this.modalHolderId);
  },
  urlParams() {
    return {};
  },
  onClick(e) {
    e.preventDefault();
    // Si debemos cerrar el modal previo, no paramos el evento de bootstrap
    if (this.$el.data('dismiss') !== 'modal') {
      e.stopPropagation();
    }
    this.loadModal();
  },
  loadModal() {
    const view = this;
    const location = this.getModalUrl();
    if (!location) {
      return;
    }
    $.ajax({
      url: location,
      data: this.getOption('urlParams')(),
      // eslint-disable-next-line object-shorthand
      beforeSend: function (jqXHR, _settings) {
        jqXHR.setRequestHeader('Accept', 'text/html');
      },
    }).done((data) => {
      view._setModalContent(data, true);
    });
  },
  initForm($modal, conectarEventosGenerales) {
    const view = this;
    // eslint-disable-next-line prefer-arrow-callback
    $modal.find('form').on('ajax:success', function onSuccess(_event, data, status, xhr) {
      view.triggerMethod('form:success', data, status, xhr);
      CHANNEL.trigger('form:success', view, data, status, xhr);
      if (view.getOption('cerrarModal') !== false) {
        view.hideModal();
      }
      // Comprobamos si hay que redireccionar
      Cifra.Utils.redirectFromHeaders(xhr, { overlay: true });
    // eslint-disable-next-line prefer-arrow-callback
    }).on('ajax:error', function onError(_event, xhr, _status, _error) {
      const html = xhr.responseText;
      if (html && !xhr.responseJSON) {
        view._setModalContent(xhr.responseText, false);
      }
      view.enableForm();
    // eslint-disable-next-line prefer-arrow-callback
    }).on('ajax:before submit', function onBeforSubmit() {
      view.disableForm();
    // eslint-disable-next-line prefer-arrow-callback, newline-per-chained-call
    }).on('ajax:complete', function onComplete() {
      view.enableForm();
    // eslint-disable-next-line prefer-arrow-callback, newline-per-chained-call
    }).on('delete:done', function onDeleteDone(event, data, status, xhr) {
      view.triggerMethod('form:success:delete', data, status, xhr);
      CHANNEL.trigger('form:success:delete', view, data, status, xhr);
      if (view.getOption('cerrarModal') !== false) {
        view.hideModal();
      }
      // Comprobamos si hay que redireccionar
      Cifra.Utils.redirectFromHeaders(xhr, { overlay: true });
    });
    // Estos eventos hay que conectarlos sólo la primera vez, no cada vez
    // que falla y se recarga el contenido, sino llamaríamos multiples veces al servidor
    if (conectarEventosGenerales) {
      $modal.on('hidden.bs.modal', function onHideModal() {
        $(this).data('bs.modal', null);
        $modal.remove();
        view.triggerMethod('modal:hide');
      // eslint-disable-next-line prefer-arrow-callback
      }).on('show.bs.modal', function onShowModal(e) {
        // El evento es show.bs.modal y jquery lo trata como namespace después del punto y lanza
        // el evento show en todos los elementos. Aquí nos aseguramos que es el show del modal
        // Si no hacemos esto, cuando hacemos un show de cualquier elemento dentro del modal,
        // se ejecuta este evento dando bucles infinitos.

        // OJO! Creo que hay algún tipo de bug porque al cargar el modal de datos de promoción no
        // se me está lanzando este evento. Habría que revisar si pasa en más sitios
        if (e.namespace !== 'bs.modal') {
          return;
        }
        view.triggerMethod('modal:show');
      // eslint-disable-next-line prefer-arrow-callback
      }).on('shown.bs.modal', function onShownModal() {
        view.triggerMethod('modal:shown');
      // eslint-disable-next-line prefer-arrow-callback
      }).on('click', '[data-btn-key=save]', function onClickSave() {
        view.getModal().find('form').submit();
      });
      this.eventosGeneralesConectados = true;
    }

    view.triggerMethod('form:initialized');
  },
  disableForm() {
    this.getModal().find('[type=submit]').attr('disabled', 'disabled');
  },
  enableForm() {
    this.getModal().find('[type=submit]').removeAttr('disabled');
  },
  _setModalContent(html, conectarEventosGenerales) {
    let $modal = this.getModal();
    if ($modal.length > 0) {
      $modal.find('.modal-dialog').first().replaceWith($(html).find('.modal-dialog'));
    } else {
      const $html = this._wrapModal(html);
      Cifra.Modals.getHolder(this.modalHolderId).html($html);
      $modal = this.getModal();
      $modal.modal();
    }
    // TODO initChecks debería de tratarse como un componente más
    init_datepicker();
    this.initForm($modal, conectarEventosGenerales);
    // Ocultamos tooltips que estuvieran abiertos. Esto pasa cuando el botón
    // que abre el modal tiene un tooltip
    Cifra.Utils.ocultarTooltips();
  },
  getModal() {
    return Cifra.Modals.getHolder(this.modalHolderId).find('.modal').first();
  },
  getForm() {
    return this.getModal().find('form');
  },
  hideModal() {
    this.getModal().modal('hide');
  },
  getModalUrl() {
    return this.getOption('modalUrl') || this.$el.attr('href');
  },
  // Miramos si el html devuelto contiene el layout de un modal. Si no
  // lo tiene, lo wrapeamos nosotros
  _wrapModal(html) {
    const $html = $(html);
    if ($html.find('.modal-dialog').length) {
      return $html;
    }
    const $modal = $(MODAL_TEMPLATE(
      { id: '', modalClasses: '', title: this.getOption('modalTitle') || '' },
    ));
    $modal.find('.modal-body').first().html($html);
    return $modal;
  },
});

export default class extends ApplicationController {
  connect() {
    const options = extend({
      el: this.element,
    }, $(this.element).data());

    this.component = new Cifra.Components.ModalHtml(options);
    this.component.render();
    this.lanzarEventoCargado();
    CHANNEL.trigger('modal:created', this.component);
  }

  urlParams(argument) {
    this.component.urlParams = argument;
  }
}
